import type { Map } from 'maplibre-gl';

/** Let Mac users start the native rotation gesture with Command as well as Control. */
export function installGlobeModifierDrag(map: Map): void {
  if (!navigator.platform.toUpperCase().includes('MAC')) return;
  const canvas = map.getCanvas();
  const onMouseDown = (event: MouseEvent) => {
    if (event.button !== 0 || !event.metaKey || event.ctrlKey || !map.dragRotate.isEnabled()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    // Only translate the start event. MapLibre owns movement, release and inertia.
    canvas.dispatchEvent(new MouseEvent('mousedown', {
      bubbles: true,
      cancelable: true,
      composed: true,
      view: event.view,
      detail: event.detail,
      screenX: event.screenX,
      screenY: event.screenY,
      clientX: event.clientX,
      clientY: event.clientY,
      button: event.button,
      buttons: event.buttons,
      ctrlKey: true,
      metaKey: event.metaKey,
      altKey: event.altKey,
      shiftKey: event.shiftKey,
    }));
  };
  canvas.addEventListener('mousedown', onMouseDown, true);
  map.once('remove', () => canvas.removeEventListener('mousedown', onMouseDown, true));
}
